/**
 * tenant          => used to mean any user for this tenant; now, it means
 *                    all users members of the tenant organization group
 *
 * owner           => only visible to the user whose ID is in the 'users' list
 *
 * selected_groups => only visible to users that are member of at least one of the groups
 *                    in the 'groups' array
 */
export const itemAccessControlLevels = <const>['tenant', 'owner', 'selected_groups'];
export type ItemAccessControlLevels = typeof itemAccessControlLevels[number];

/**
 * This interface defines the data model used to impose different types of access
 * restrictions on an item.
 */
export interface ItemAccessControl {
  /**
   * The level of restriction for this item.
   * If this property exists, only certain parameters will be checked based on its value. For example, if the level is 'selected_groups',
   * the 'groups' parameter will determine if access should be allowed.
   * If this property doesn't exist, each parameter will be evaluated to determine access.
   */
  level?: ItemAccessControlLevels;
  /**
   * List of group IDs this item is accessible to. Will be checked if 'level' is undefined or 'selected_groups'.
   */
  groups?: string[];
}
